module.exports = __webpack_public_path__ + "img/uv_4.141d3d44.png";